import React from "react";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {TableContainer, Typography} from "@material-ui/core";
import {formatPrice} from "assets/utils";
import Box from "@material-ui/core/Box";

const sortByKey = (data, key) => data.sort((a, b) => (parseFloat(b[key]) - parseFloat(a[key])));
const markSumNByValue = (data, key, n) => {
    const itemsSumN = data
        .reduce((acc, elem) => acc.porc < n ? ({items: [...acc.items, elem], porc: acc.porc + elem[key]}) : acc, {items: [], porc: 0})
        .items;
    data.forEach(item => {item.topn = false});
    itemsSumN.forEach(item => {item.topn = true});
}

export const RankingTable = React.memo(function ({detailTitle, detailField, height, data, id, value, printRef}) {
    sortByKey(data, value.id);

    if (id !== 'codigo') // Solo clientes
        markSumNByValue(data, value.id === 'cantidad' ? 'porc_cant' : 'porc_importe', 0.8);

    return (
        (data.length <= 0) ?
            <Box style={{height: '25rem'}}>
                <Typography align={"center"} color={"textSecondary"}>
                    No hay datos para mostrar
                </Typography>
            </Box> :
            <TableContainer style={{height: '25rem'}}>
                <Table size="small" stickyHeader aria-label="a dense table" ref={printRef} id={`table_${Math.floor(Math.random() * 10000)}`}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Pos</TableCell>
                            {id === 'codigo' && ( // solo articulos
                                <TableCell align="left">Código</TableCell>
                            )}
                            <TableCell align="left">Detalle</TableCell>
                            {id === 'codigo' && ( // solo articulos
                                <TableCell align="left">Línea</TableCell>
                            )}
                            {value.id === 'cantidad' && (
                                <TableCell align="left">Cantidad</TableCell>
                            )}
                            {value.id === 'importe' && (
                                <TableCell align="left">Importe</TableCell>
                            )}
                            <TableCell align="right">Porc.</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow key={index} style={{background: row.topn ? 'rgba(255,179,26,0.22)' : ''}}>
                                <TableCell component="th" scope="row" align={"center"}>
                                    {`${row.topn ? '(' : ''}${(index + 1)}${row.topn ? ')' : ''}`}
                                </TableCell>
                                {id === 'codigo' && ( // solo articulos
                                    <TableCell align="left" style={{wordBreak: 'break-all'}}>{row.id}</TableCell>
                                )}
                                <TableCell align="left" style={{wordBreak: 'break-all'}}>{row.detalle}</TableCell>
                                {id === 'codigo' && ( // solo articulos
                                    <TableCell align="left" style={{wordBreak: 'break-all'}}>{row.lindet}</TableCell>
                                )}
                                {value.id === 'cantidad' && (
                                    <>
                                        <TableCell align="right">{row.cantidad}</TableCell>
                                        <TableCell align="right">{(row.porc_cant * 100).toFixed(2)}%</TableCell>
                                    </>
                                )}
                                {value.id === 'importe' && (
                                    <>
                                        <TableCell align="right">{formatPrice(row.importe)}</TableCell>
                                        <TableCell align="right">{(row.porc_importe * 100).toFixed(2)}%</TableCell>
                                    </>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    )
})
